var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aspect-ratio-parent"},[_c('div',{staticClass:"aspect-ratio-container",style:(_vm.aspectPadding)},[_c('div',{staticClass:"aspect-ratio-inner"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }